import { CampaignMaterialFloatingToolBarController } from './campaign-material-floating-tool-bar.controller'

function campaignMaterialFloatingToolBar () {
  return {
    restrict: 'E',
    scope: {
      selectedMaterials: '=',
      action: '=',
      campaign: '='
    },
    templateUrl: '/campaigns/directives/campaign-material-floating-tool-bar/campaign-material-floating-tool-bar.html?$$REVISION$$',
    controller: CampaignMaterialFloatingToolBarController
  }
}

export { campaignMaterialFloatingToolBar }
